import React from "react";
//import {contentURL} from "src/utilities/utilityFunctions";
//import TDPAboutNewsletter from "../content/TDPAboutNewsletter";
//import SubscribeNewsletter from "../newsletter/SubscribeNewsletter";

const TerminologySlide=(props)=>{
    return (
        <div className="ls-slide" data-ls="slidedelay:17000; transition2d: all;">
            <img className="ls-l" style={{left:"-524px",top:"0px",whiteSpace: "nowrap"}}
                 src="images/TerminologySlideImages/leftFrame.png" alt="" />
            <img className="ls-l" style={{left:"1262px",top:"0px",whiteSpace: "nowrap"}}
                 src="images/TerminologySlideImages/rightFrame.png" alt="" />

            <img className="ls-l" style={{left:"0px",top:"0px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:500;easingin:easeOutElastic;skewxin:30;skewyin:30;transformoriginin:50% 0% 50%;offsetxout:0;parallaxlevel:1;"
                 src="images/TerminologySlideImages/family-game.png" alt="" />
            <img className="ls-l" style={{left:"311px",top:"0px",zIndex:100,whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:80;delayin:600;offsetxout:0;offsetyout:-80;"
                 src="images/TerminologySlideImages/number1.png" alt=""/>
            <img className="ls-l" style={{left:"367px",top:"10px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:2;delayin:700;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:-1;"
                 src="images/TerminologySlideImages/text1.png" alt=""/>
            <img className="ls-l" style={{left:"507px",top:"236px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:800;scalexin:3;scaleyin:3;offsetxout:0;parallaxlevel:-2;"
                 src="images/TerminologySlideImages/arrow1.png" alt=""/>

            <img className="ls-l" style={{left:"712px",top:"0px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:1000;easingin:easeOutElastic;skewxin:30;skewyin:30;transformoriginin:50% 0% 50%;offsetxout:0;parallaxlevel:1;"
                 src="images/TerminologySlideImages/black-mom-and-daughter.png" alt="" />
            <img className="ls-l" style={{left:"659px",top:"233px",zIndex:100,whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:80;delayin:1100;offsetxout:0;offsetyout:-80;"
                 src="images/TerminologySlideImages/number2.png" alt=""/>
            <img className="ls-l" style={{left:"703px",top:"247px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:2;delayin:1200;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:-1;"
                 src="images/TerminologySlideImages/text2.png" alt=""/>
            <img className="ls-l" style={{left:"1066px",top:"249px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:1300;scalexin:3;scaleyin:3;offsetxout:0;parallaxlevel:-2;"
                 src="images/TerminologySlideImages/arrow2.png" alt=""/>

            <img className="ls-l" style={{left:"511px",top:"298px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:1500;easingin:easeOutElastic;skewxin:30;skewyin:30;transformoriginin:50% 0% 50%;offsetxout:0;parallaxlevel:1;"
                 src="images/TerminologySlideImages/vid-call.png" alt="" />
            <img className="ls-l" style={{left:"999px",top:"309px",zIndex:100,whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:80;delayin:1600;offsetxout:0;offsetyout:-80;"
                 src="images/TerminologySlideImages/number3.png" alt=""/>
            <img className="ls-l" style={{left:"855px",top:"353px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:2;delayin:1700;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:-1;"
                 src="images/TerminologySlideImages/text3.png" alt=""/>
            <img className="ls-l" style={{left:"507px",top:"316px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:1800;scalexin:3;scaleyin:3;offsetxout:0;parallaxlevel:-2;"
                 src="images/TerminologySlideImages/arrow3.png" alt=""/>

            <img className="ls-l" style={{left:"14px",top:"316px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2000;easingin:easeOutElastic;skewxin:30;skewyin:30;transformoriginin:50% 0% 50%;offsetxout:0;parallaxlevel:1;"
                 src="images/TerminologySlideImages/space-game.png" alt="" />
            <img className="ls-l" style={{left:"461px",top:"388px",zIndex:100,whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:80;delayin:2100;offsetxout:0;offsetyout:-80;"
                 src="images/TerminologySlideImages/number4.png" alt=""/>
            <img className="ls-l" style={{left:"21px",top:"332px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:2;delayin:2200;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:-1;"
                 src="images/TerminologySlideImages/text4.png" alt=""/>
        </div>


    )
};
/*
            <img className="ls-l" style={{top:"42px",left:"173px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:150;delayin:2200;easingin:easeInOutBack;offsetxout:0;offsetyout:-150;parallaxlevel:-4;"
                 src="https://wedesignthemes.com/html/kidslife/images/layerslider-gallery/girl2.png" alt=""/>
 */
export default TerminologySlide;
